<script>
export default {
    name: "WorkWithUsLineBottom"
}
</script>
<template>
    <svg aria-hidden="true" viewBox="0 0 20 83" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1 73L10 82L19 73" stroke="#6B919B"/>
        <path d="M10 82L10 2.20537e-06" stroke="#6B919B"/>
    </svg>
</template>
